<template>
	<article class="login-page">
		<div class="login__box" v-if="typeof isLogin === 'boolean'">
			<h1 class="login__title" v-if="isLogin">
				환영합니다. {{ name }} 님
			</h1>
			<div class="search-by-enter__container" v-else>
				<h1 class="login__title">로그인이 필요합니다.</h1>
				<form autocomplete="on" @submit.prevent.stop>
					<input
						class="search-by-enter__target"
						type="text"
						placeholder="아이디를 입력하세요."
						name="eMail"
						ref="eMail"
						v-model="eMail"
						:autofocus="!saveId"
					/>
					<input
						class="search-by-enter__target login__password"
						type="password"
						placeholder="비밀번호를 입력하세요."
						name="passWord"
						ref="passWord"
						v-model="passWord"
						:autofocus="saveId"
					/>
				</form>
				<label class="login__id-saver">
					<input
						class="search-by-enter__target login__id-saver__input"
						type="checkbox"
						v-model="saveId"
					/>
					<span class="login__id-saver__text"
						>아이디 저장기능 사용</span
					>
				</label>
				<form
					v-if="isExternalIp"
					autocomplete="off"
					@submit.prevent.stop
				>
					<input
						class="search-by-enter__target login__otp"
						type="text"
						placeholder="보안키를 입력하세요."
						ref="otp"
						v-model="otp"
					/>
				</form>
				<button
					class="btn-main blue login__login-btn"
					type="button"
					@click="login"
				>
					로그인
				</button>
			</div>
		</div>
	</article>
</template>

<script>
	import { addAuthCookie } from '@/util.js';
	import { mapState } from 'vuex';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'Login',
		extends: SearchByEnter,
		data() {
			return {
				isLogin: null,
				eMail: '',
				passWord: '',
				saveId: false,
				isExternalIp: false,
				otp: '',
			};
		},
		computed: {
			...mapState({
				adminDomain: state => state.env.adminDomain,
				name: state => state.login.name,
				NODE_BUILD: state => state.env.NODE_BUILD,
			}),
		},
		created() {
			this.init();
		},
		methods: {
			goBeforePage() {
				const next = this.$route.params.next;
				const referrer = document.referrer;
				if (
					referrer.indexOf(this.adminDomain) > -1 &&
					referrer.indexOf('login') < 0
				) {
					window.location.replace(referrer);
				} else if (next && next.indexOf('login') < 0) {
					this.$router.replace(next);
				} else {
					this.$router.push('/');
				}
			},
			async init() {
				if (this.NODE_BUILD) {
					const { data } = await this.$axiosAuth.post(
						'/public/admin.auth/is-external-ip'
					);
					this.isExternalIp = data.isExternalIp;
				}
				const saveId = localStorage.getItem('saveId');
				if (saveId) {
					this.eMail = saveId;
					this.saveId = true;
				}
				this.isLogin = await this.$store.dispatch('login/tokenVerify');
				if (this.isLogin) {
					this.goBeforePage();
				}
				this.$nextTick(() => {
					this.setSearchByEnter();
				});
			},
			async login() {
				try {
					const eMail = this.eMail;
					const passWord = this.passWord;
					const otp = this.otp;
					if (!eMail) {
						alert('아이디를 입력하세요');
						this.$refs.eMail.focus();
						return;
					}
					if (!passWord) {
						alert('비밀번호를 입력하세요');
						this.$refs.passWord.focus();
						return;
					}
					if (this.isExternalIp && !otp) {
						alert('보안키를 입력하세요');
						this.$refs.otp.focus();
						return;
					}
					const params = { eMail, passWord, otp };
					const { data } = await this.$axiosAuth.post(
						'/public/admin.auth/token/login',
						params
					);
					addAuthCookie(data.access_token);
					localStorage.setItem('access_token', data.access_token);
					localStorage.setItem('refresh_token', data.refresh_token);
					if (this.saveId) {
						localStorage.setItem('saveId', eMail);
					} else {
						localStorage.removeItem('saveId');
					}

					this.goBeforePage();
				} catch ({ response }) {
					let msg = '로그인 실패';
					if (
						response &&
						response.data.error &&
						response.data.error.message
					) {
						msg = response.data.error.message;
					}
					alert(msg);
					console.error(response);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.login-page {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #303643;
		padding: 42px 0;
	}

	.login__box {
		width: 330px;
		margin: 0 auto;
		padding: 18px;
	}

	.login__title {
		margin-bottom: 12px;
		color: white;
		font-size: 2rem;
	}

	.login__password {
		margin: 12px 0;
	}

	.login__id-saver {
		cursor: pointer;
		display: block;
		padding: 8px 0;
		border-radius: 4px;
		color: white;
		font-size: 0;

		&:hover {
			background-color: rgba(0, 0, 0, 0.2);
		}
	}

	.login__id-saver__input {
		display: inline-block;
		font-size: 1.063rem;
		vertical-align: middle;
	}

	.login__id-saver__text {
		display: inline-block;
		margin-left: 8px;
		font-size: 1.063rem;
		vertical-align: middle;
	}

	.login__otp {
		margin-top: 12px;
	}

	.login__login-btn {
		width: 100%;
		margin: 24px 0 0 0;
	}
</style>
